@if (data?.length > 0) {
  <dx-table
    [pagesize]="dxPageSize() ?? pageSize"
    [pagesizes]="dxPageSizes()"
    [rowcount]="totalElements"
    [mode]="paginated ? 'remote' : 'managed'"
    (tableStateChanged)="handleTableStateChanged($event)"
  >
    <dx-table-header>
      @for (column of columns; track column; let i = $index) {
        <dx-table-header-item
          class="spa-table-col-{{ column.key }}"
          data-testid="column_header"
          id="col-{{ column.key }}"
          label="{{ (translationKey(column) | transloco) || null }}"
          linesize="l"
          [align]="column.settings?.align"
          [maxwidth]="column.settings?.sizeStyle?.maxWidth"
          [minwidth]="column.settings?.sizeStyle?.minWidth"
          [type]="getTemplate(column.key) ? 'html' : column.settings?.type || 'text'"
        />
      }
      @if ((rowDelete.observed && !hideDeleteIcon()) || showDetailIcon) {
        <dx-table-header-item label="" linesize="l" type="html" [maxwidth]="60" />
      }
    </dx-table-header>

    <ng-container>
      @for (row of data; track row.element; let i = $index) {
        <dx-table-row
          class="spa-row spa-row-{{ i }}"
          [id]="'row-' + row.element[rowId]"
          [ngClass]="{
            selected: areSame(selectedRow, row),
            interactive: selectedRowChange.observed && !hideSelectedRow(),
          }"
          [unread]="row.updated || row.created"
          (click)="onRowSelect(row)"
        >
          @for (column of columns; track column; let j = $index) {
            <ng-container>
              <dx-table-cell
                class="spa-cell spa-cell-{{ column.key }}"
                id="cell-{{ i }}-{{ j }}"
                lang="de"
                [value]="cellValue(row, column)"
              >
                @if (getTemplate(column.key); as tpl) {
                  <ng-container *ngTemplateOutlet="tpl.template; context: { row }" />
                }
              </dx-table-cell>
            </ng-container>
          }
          @if (rowDelete.observed && !hideDeleteIcon()) {
            <dx-table-cell>
              @if (areSame(row, selectedRow)) {
                <spa-button
                  data-testid="remove_button"
                  shape="primary"
                  [disabled]="deleteDisabled && deleteDisabled(row)"
                  [icon]="deleteIcon()"
                  (clickedButton)="onRowDelete(row)"
                />
              }
            </dx-table-cell>
          }

          @if (showDetailIcon) {
            <dx-table-cell class="spa-cell spa-cell-detail" id="cell-{{ i }}-detail">
              <spa-icon>arrow_forward_ios</spa-icon>
            </dx-table-cell>
          }
        </dx-table-row>
      }
    </ng-container>
  </dx-table>
} @else {
  <div class="spa-no-data" data-testid="no_data">
    {{ noDataLabel }}
  </div>
}

@if (loading) {
  <div class="spa-spinner">
    <dx-loading-indicator size="medium" theme="light" />
  </div>
}
